export default {
  website: {
    shoutoutSliderText1:
      'Stream games from Ligue 1, Serie A, Bundesliga, Premier League, NFL, NBA, NCAA and many more!',
    'shoutout!': 'Shoutout!',
    loveTheGame: 'LOVE THE GAME. MAKE IT YOURS.',
    joinTheDedicated:
      'Join the dedicated sports social network – an ecosystem that’s stronger with sponsors and partners.',
    aSportsCommunity: 'A sports community marketplace.',
    athletesMonetize: 'Athletes monetize their brand.',
    fansConnectDirectly: 'Fans connect directly with athletes.',
    ledByAthletes: 'LED BY ATHLETES.',
    ledByFans: 'LED BY FANS.',
    ledBy: 'LED BY',
    'athletes.': 'ATHLETES.',
    'fans.': 'FANS.',
    goToApp: 'Go to app',
    logout: 'Logout',
    amAnAthlete: "I'm an athlete",
    monetizeYourBrand: 'Monetize your brand by creating a unique world with your fans.',
    amAFan: "I'm a fan",
    connectDirectlyWith: 'Connect directly with your favourite athletes and other fans.',
    athleteZone: 'ATHLETE ZONE',
    fanZone: 'FAN ZONE',
    ourAthletes: 'OUR ATHLETES',
    news: 'News',
    ourStory: 'OUR STORY',
    sponsors: 'SPONSORS',
    pricing: 'Pricing',
    PRICING: 'PRICING',
    contact: 'CONTACT',
    athleteFocus: 'Athlete focus',
    calculator: 'Calculator',
    seeHowMuch: 'See how much your brand could make you.',
    weAllPlay: 'WE ALL PLAY BETTER TOGETHER.',
    everybody: 'EVERYBODY',
    playsBetter: 'PLAYS BETTER',
    weAll: 'WE ALL',
    playBetter: 'PLAY BETTER',
    together: 'TOGETHER.',
    video: 'Video',
    tiffanyVan: 'Tiffany Van Soest',
    goto: 'Go to',
    athleteZoneSmall: 'Athlete zone',
    latestNews: 'LATEST NEWS',
    ledByPartners: 'LED BY PARTNERS.',
    partnersAndSponsors: 'Partners and Sponsors',
    ledByTeams: 'LED BY TEAMS.',
    seeOurWork: 'See our work with these top athletes',
    sportsCareer:
      'Sports careers can be short, but you’ve gained a lifetime of experience. Now it’s time to reap the rewards.,',
    buildAnOngoing: 'Build an ongoing, sustainable income.,',
    takeControl: 'Take control of your brand – and your future.,',
    signUpForFree: 'Sign up for free to calculate how much your career can keep on giving you.,',
    'connect!': 'Connect!',
    unlimitedAccess:
      'Unlimited access to your favorite athletes. Build your own network of sports heroes!',
    'stream!': 'Stream!',
    streamGamesFrom:
      'Stream games from Ligue 1, Serie A, Bundesliga, Premier League, NFL, NBA, NCAA and many more!',
    stayVisible: 'STAY VISIBLE.',
    connectWithUs: 'Connect with us',
    newsletter: 'Newsletter',
    typeEmail: 'Type email here and hit enter',
    typeAndEnter: 'Type email here and hit enter',
    wedLoveTo: "We'd love to hear from you.",
    sendUsAMessage: 'Send us a message',
    notAnAthleteOrFan: 'Not an athlete or fan?',
    connectWithUsHere: 'Connect with us here anyway!',
    home: 'Home',
    fanZoneSmall: 'Fan zone',
    ourStorySmall: 'Our story',
    ourAthletesSmall: 'Our athletes',
    selectCountry: 'Select country',
    signUp: 'Sign up',
    stopTheHate: 'Stop The Hate',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'All rights reserved',
    led: 'LED',
    byTopAthletes: 'BY TOP ATHLETES',
    partners: 'Partners',
    investors: 'Investors',
    attendees: 'Attendees',
    date: 'April 26-29',
    location: 'Wesley Chapel, Florida',
    dontMiss: "DON'T MISS",
    outOn: 'OUT ON',
    your: 'YOUR',
    timeToShine: 'TIME TO SHINE.',
    registerForCombine: 'Register For Combine',
    registrationEnds: 'REGISTRATION ENDS',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    ourPartners: 'OUR PARTNERS.',
    enjoyTheseMembership: 'Enjoy these amazing membership features',
    sportUnites: 'SPORT UNITES.',
    noDivide: 'NO DIVIDE.',
    videosArticles: 'Videos, articles and interviews with sports stars',
    instantMessaging: 'Instant messaging with your favorite athletes',
    discountOnEvent: 'Discounts on event tickets and merch',
    behindTheScenes: 'Behind the scenes access to the world of sport',
    experienceSport: 'EXPERIENCE SPORT THE WAY YOU LOVE IT.',
    theOnlySportsApp:
      'The only sports app that gives you direct contact with your favorite athletes – in real time!',
    buildYourOwnWorld: 'Build your own world by connecting directly with athletes – the real deal.',
    chooseTheFeatures: 'Choose the features you love.',
    interactWithAthletes: 'Interact with athletes – and be inspired!',
    sendAShoutout:
      'Send a shoutout to your athlete or team right before – or even during – the game!',
    fanLife: '#FANLIFE',
    highlights: 'Highlights',
    recentArticles: 'Recent Articles',
    p4pxIra: 'p4p x Ira Brown',
    uploadedDate: 'Uploaded 28 February 2022',
    youMightAlso: 'You might also like...',
    'subscribe!': 'Subscribe!',
    getContent:
      ' Get content and streaming for your favorite sport - or all the sports on playaz4playaz!',
    'vipConnects!': 'VIP Connects!',
    '1-to-1connections':
      '1-to-1 connections with your favourite athlete, either virtually or in-person!',
    watch: 'Watch: the p4p story',
    caseStudies: 'Case studies',
    aboutHenrySeals:
      "A graduate of Harvard University, Henry is an experienced people leader. Currently Henry is the CHRO for Zaiko, a Japan based startup that supports creators in engaging their fans through digital and hybrid engagement.  He is also Japan's first foreign born human rights commissioner and the founder of the Legacy Foundation Japan. \u000bAs the CHRO for Paidy, he helped them become a one of Japan's only unicorns (billion-dollar valuation companies) and become publicly traded in 2021.\nHe has also held senior HR positions for Philip Morris International, AIG, and NN.\n\n",
    aboutHoustonRoss:
      'Houston has years of experience leading global organizations in preparing for the future, modernizing operations and infrastructure, and developing teams to perform at a high level.  Most recently Houston was the CTO for Japan BNPL-unicorn Paidy, leading the organization towards a successful public exit.\nA global leader, Houston has held the role of CTO for Global Finance Organizations such as AXA Life, ING, and NN.  \nA sports enthusiast, he aims to leverage his experience in technology, finance, and operational excellence to make P4P a global leader.',
    aboutJuliusGoldsmith:
      "Julius is a lawyer with over 20+ years of Wall St. experience in the areas of Business Development, New Product Development, and cross border transactions. Julius has worked in New York City, London, Singapore and Tokyo wherein he has extensive experience working across multiple disciplines including business development, finance, legal and tax related matters.  Julius is a member of the Dean's Advisors to the Silberman College of Business at Fairleigh Dickinson University (his alma mater) and also holds a CPA.  ",
    aboutMarcelVanDruten:
      'Marcel Van Druten is a seasoned professional with a proven record of achievement in global technology environments. Born and raised in Amsterdam, The Netherlands, until the age of 21 Marcel actively played football as a fearless defender in the highest amateur leagues at various Football Clubs. \nLeveraging his deep marketing and advertising expertise, Marcel has helped global brands develop and implement programs and initiatives aimed at enhancing revenues and promoting brand awareness. Multilingual in English, Dutch, and German, and with a great passion for martial arts, golf and formula 1, Marcel is helping P4P become the best Sports App in the world.\n',
    aboutMichaelAJacobs:
      'Michael is a senior executive and legal professional with a diverse record of success improving multi-site operations through superior community engagement; human resources; labor and employee relations and legal experience.  Currently, he is a senior lecturer at the New York University, Robert F. Wagner Graduate School of Public Service and Adjunct Associate Professor at The City University of New York, School of Professional Studies.  Michael was previously an adjunct faculty member at University of Maryland Global Campus (formerly, University of Maryland University College) and Howard University School of Law. \n',
    aboutMichaelJackson:
      'A graduate of Columbia University, Michael is an experienced product manager and the former regional head of delivery for global asset and wealth management organizations.  He has years of experience delivering global projects aimed at improving operational efficiency and service\/product delivery. \n \n',
    sponsorsSmall: 'Sponsors',
    becomeASponsor: 'BECOME A P4P SPONSOR',
    content1: 'Lorem ipsum...',
    content2: 'Lorem ipsum...',
    ourTeams: 'OUR TEAMS.',
    paymentDetails: 'PAYMENT DETAILS',
    cancelWithin30Days:
      'Cancel within 30 days and your card won’t be charged. You will still be able to access basic features.',
    cardNumber: 'CARD NUMBER',
    expiry: 'EXPIRY',
    cvc: 'CVC',
    illDoItLater: 'Ill do it later',
    submit: 'Submit',
    athleteInformation: 'ATHLETE INFORMATION',
    contactInformation: 'CONTACT INFORMATION',
    otherInformation: 'OTHER INFORMATION',
    dateOfBirth: 'DATE OF BIRTH',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    socialNetworks: 'SOCIAL NETWORKS',
    Instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    uploadHeadshot: 'Upload headshot or basketball action shot',
    phoneNumber: 'Phone number',
    sport: 'Sport',
    linkInstagram: 'Link to your Instagram profile',
    linkFacebook: 'Link to your Facebook profile',
    linkTwitter: 'Link to your Twiiter profile',
    athleteSignUp: 'athleteSignup',
    thankYou: 'THANK YOU',
    youWillBeSent: 'You will be sent an email confirmation shortly.',
    getTheApp: 'GET THE APP!',
    or: 'OR',
    continueOnWebsite: 'Continue on website',
    welcome: 'WELCOME!',
    '30dayFull': '30-day full access!',
    enjoyTheseAmazing: 'Enjoy these amazing features for free, no strings attached!',
    yesGiveMe: 'Yes, give me free access!',
    noThanksKeep: 'No thanks, keep it basic',
    letsWorkTogether: 'Let’s work together! Please fill in your details and we will be in touch.',
    yourDetails: 'YOUR DETAILS',
    firstName: 'First name',
    lastName: 'Last name',
    emailAddress: 'Email address',
    companyInformation: 'COMPANY INFORMATION',
    companyName: 'Company name',
    companyWebsite: 'Company website',
    login: 'Login',
    getApp: 'get App',
    letsTalk: "Let's talk",
    sponsor: 'Sponsor',
    useTheApp: 'Use the APP',
    messageSent: 'Message succesfully sent.',
    invalidEmail: 'Email Invalid.',
    addedToNewsletter: 'Email successfully added to newsletter.',
    recently: 'Recently',
    downloadTheApp: 'Download the playaz4playaz APP for your smartphone.',
    getMobileApp: 'Get mobile APP',
    childSafety: 'Child Safety Standard Policy',
    communityGuidelines: 'Community Guidelines'
  }
};
